import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Icon } from 'semantic-ui-react';

export default function CostCentersInput({
  type,
  data,
  value,
  onChangeCostCenter,
  onChangeCostCenterDocuments,
  index,
  costCenterSelected,
  multiple = true,
  EERR = false
}) {
  const { t } = useTranslation('reports');
  const costCenter = data || [];

  const opciones = [
    ...(multiple
      ? [{ key: "todos", text: t('hr.allCostCenters'), value: "todos" }]
      : []),
    ...costCenter.map(c => ({
      key: c.id,
      text: c.name,
      value: c.id
    })),
    ...(EERR ?
      [{ key: "sinCentroDeCosto", text: t('hr.noCostCenter'), value: "sinCentroDeCosto" }]
      :
      ''
    )
  ];

  const manejarSeleccion = (e, { value: valueDropdown }) => {
    let result;

    // Asegurar que `value` sea siempre un arreglo
    const currentValue = Array.isArray(value) ? value : [value];

    if (valueDropdown.includes("todos")) {
      result = [...data.map(c => c.id)];
      if (EERR) {
        result.push("sinCentroDeCosto");
      }
    } else if (e.target.className === "delete icon") {
      result = Array.isArray(valueDropdown) ? valueDropdown : [valueDropdown];
    } else {
      if (multiple) {
        result = [...currentValue];
        if (!result.includes(valueDropdown)) {
          result.push(valueDropdown);
        }
      }else{
        result = [valueDropdown]
      }
    }

    if (onChangeCostCenter) {
      onChangeCostCenter(result);
    } else {
      onChangeCostCenterDocuments(result, index);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <Dropdown
        placeholder={t('hr.costCenterPlaceholder')}
        fluid
        multiple={multiple}
        selection
        options={opciones}
        value={value}
        onChange={manejarSeleccion}
      >
        <Dropdown.Menu>
          <Dropdown.Header />
          {costCenter.length > 0 &&

            opciones.map(opcion => (
              <Dropdown.Item
                key={opcion.key}
                value={opcion.value}
                onClick={(e, data) => manejarSeleccion(e, data)}
              >
                {opcion.text}
              </Dropdown.Item>
            ))
          }
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

// export default CostCentersInput;
